import React, { useState } from "react";
import auth_service from "../services/auth-service";
import { setToken } from "../utils/token";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await auth_service.login({ username, password });
      //console.log("Login successful:", response.message);
      if (response.message === "Login successful") {
        setToken(response.token);
        navigate("/admin");
      }
    } catch (error) {
      console.error("Login failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="main">
      <div className="d-flex justify-content-center vh-100">
        <div className="p-5">
          <h2 className="text-center text-primary fw-bold">AUTHENTIFICATION</h2>
          <form onSubmit={handleSubmit}>
            {/* Champ Login */}
            <div className="mb-3">
              <label className="form-label">Login</label>
              <input
                type="text"
                className="form-control"
                placeholder="Entrez votre login"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={isLoading}
              />
            </div>

            {/* Champ Mot de passe */}
            <div className="mb-3">
              <label className="form-label">Mot de passe</label>
              <input
                type="password"
                className="form-control"
                placeholder="Entrez votre mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Connexion...
                </>
              ) : (
                "Connexion"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
